import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

import { Button, TableCell, TableRow, Typography } from '@mui/material';

import { LinkText } from 'common/components';
import {
  DeleteOutline as DeleteOutlineIcon,
  PreviewOutlined as PreviewIcon,
} from '@mui/icons-material';

import { isEven } from 'utils/helpers';
import { colors } from 'themes';

const TemplateItem = ({ handlePreviewTemplate, handleRemoveTemplate, index, name, uuid }) => {
  const { organizationUuid, type } = useParams();

  return (
    <TableRow sx={{ backgroundColor: isEven(index) ? colors.alabaster : colors.white }}>
      <TableCell sx={{ fontWeight: 'bold' }}>
        <LinkText color="inherit" to={`/${organizationUuid}/create-template/${type}/${uuid}`}>
          <Typography variant="body1">{name}</Typography>
        </LinkText>
      </TableCell>
      <TableCell align="right">
        <Button onClick={() => handlePreviewTemplate(uuid)} startIcon={<PreviewIcon />}>
          Preview
        </Button>
        <Button
          color="error"
          onClick={() => handleRemoveTemplate(uuid)}
          startIcon={<DeleteOutlineIcon />}
        >
          Delete
        </Button>
      </TableCell>
    </TableRow>
  );
};

TemplateItem.propTypes = {
  handlePreviewTemplate: PropTypes.func.isRequired,
  handleRemoveTemplate: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  uuid: PropTypes.string.isRequired,
};

export default TemplateItem;
